export default {
  subheadline: 'Nakonfigurujte notifikačné služby',
};
